import React, { useCallback, useContext, useEffect, useState } from 'react';
import ApiService from 'services/api';
import { ICardItem } from 'interfaces/CardItem';
import AuthContext from './AuthContext';

interface OrganizationProviderProps {
  children: React.ReactNode;
}

const OrganizationContext = React.createContext<{
  data: {
    defaultCards: ICardItem[];
  };
}>({
  data: {
    defaultCards: [],
  },
});

export function OrganizationProvider(
  props: OrganizationProviderProps
): React.ReactElement {
  const { children } = props;
  const {
    data: { authToken },
    actions: { isLoggedIn },
  } = useContext(AuthContext);

  const [defaultCards, setDefaultCards] = useState<ICardItem[]>([]);

  const getDefaultCards = useCallback(() => {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const response = await ApiService.get(`default_context`, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        setDefaultCards(response.data.cards);
        resolve(response.data);
      } catch (e: any) {
        reject(e);
      }
    });
  }, []);

  useEffect(() => {
    if (isLoggedIn()) getDefaultCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authToken, isLoggedIn]);

  return (
    <OrganizationContext.Provider
      value={{
        data: {
          defaultCards,
        },
      }}
    >
      {children}
    </OrganizationContext.Provider>
  );
}
export default OrganizationContext;
